<template>
    <div class="wrapper">
      <div class="topo-header centro">
        <botao-voltar nomeRota="TipoMandato" />
        <h1>{{ tipoMandatoForm.id ? "Editar" : "Novo" }} Tipo de Mandato</h1>
      </div>
      <div class="tab-dados-basicos">
        <div class="form centro">
          <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />
          <p class="texto-asterisco">Os campos com asterisco (*) são de preenchimento obrigatório.</p>
          <form @submit.prevent="enviarForm">
            <div class="caixa-form">
                <div class="flexbox">
                    <div class="item">
                        <label><b>{{ possuiAsterisco("Nome:") }}</b></label>
                        <input type="text" placeholder="Digite o nome" v-model="tipoMandatoForm.nome" />
                    </div>
                    <div class="item">
                        <label><b>{{ possuiAsterisco("Código:") }}</b></label>
                        <input type="number" min="1" max="9" v-model="tipoMandatoForm.codigo" @input="inRange(tipoMandatoForm.codigo)"  placeholder="Digite o código"  />
                    </div>
                
                    <div class="item">
                        <div class="radio">
                            <label class="radio-label"><b>{{ possuiAsterisco("Ativo") }}</b></label>
                            <div class="radio-item">
                                <div class="options">
                                    <label for="sim-ativo-tipo-mandato">Sim</label>
                                    <input type="radio" id="sim-ativo-tipo-mandato" name="radioOptions" value="true" v-model="tipoMandatoForm.ativo" />
                                </div>
                                <div class="options">
                                    <label for="nao-ativo-tipo-mandato">Não</label>
                                    <input type="radio" id="nao-ativo-tipo-mandato" name="radioOptions" value="false" v-model="tipoMandatoForm.ativo" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bt-salvar">
              <button id="botao-salvar" title="Criar/Atualizar" type="submit">
                <img id="spinner-loading" class="spinner-loading" src="../../assets/imagens/loadingSpinner.gif" alt="Spinner de carregamento">
                <p id="conteudo-botao">{{ tipoMandatoForm.id ? "Atualizar" : "Criar" }}</p>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
</template>
  
<script>
  import TipoMandatoApi from '../../services/TipoMandatoApi'; // Importando a API correta
  import BotaoVoltar from '../../components/BotaoVoltar.vue';
  import MsgErroFormularios from '../MsgErroFormularios';
  
  export default {
    name: 'TipoMandatoForm',
    props: {
      tipoMandato: {
        type: Object,
        required: false,
      },
      nomeRota: String,
    },
    data() {
      return {
        erro: false,
        msgErros: {
          codigo: '',
          nome: '',
          ativo: '',
          default: '',
        },
        tipoMandatoForm: this.tipoMandato 
        ? {
            id: this.tipoMandato.id,
            codigo: this.tipoMandato.codigo,
            nome: this.tipoMandato.nome,
            ativo: this.tipoMandato.ativo,
        }
        : {
            id: null,
            codigo: null,
            nome: null,
            ativo: null,
        }
      };
    },
    components: {
      BotaoVoltar,
      MsgErroFormularios,
    },
    created() {
        this.tipoMandatoApi = new TipoMandatoApi();
    },
    methods: {
      async enviarForm() {
        try {
          const flag = this.validarForm(this.tipoMandatoForm);
          if (flag === 1) {
            this.erro = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
  
          const data = await this.tipoMandatoApi.setTipoMandato(this.tipoMandatoForm); // Chamando o método correto
  
          // Redirecionar para a rota de visualização após a submissão bem-sucedida
          this.$router.push({
            name: 'TipoMandatoShow',
            params: {
              id: data.id,
            },
          });
        } catch (err) {
          console.error('Erro ao enviar formulário:', err);
          console.error(err);
          this.erro = true;
          const { response } = err;
          if (response && response.data) {
            this.msgErros = response.data;
          } else {
            this.msgErros = 'Houve um erro ao salvar o registro. Por favor, tente novamente.';
          }
        }
      },
      validarForm(tipoMandatoForm) {
        let flag = 0;
        this.msgErros = {
          codigo: '',
          nome: '',
          ativo: '',
          default: '',
        };
  
        if (!tipoMandatoForm.codigo) {
            this.msgErros.codigo = 'O campo código não foi preenchido.';
            flag = 1;
        }
        if (!tipoMandatoForm.nome) {
            this.msgErros.nome = 'O campo nome não foi preenchido.';
            flag = 1;
        }
        if (tipoMandatoForm.ativo === null) {
            this.msgErros.ativo = 'O campo ativo não foi selecionado.';
            flag = 1;
        }

        return flag;
      },
      possuiAsterisco(texto) {
        return '* ' + texto;
      },
      fecharErro() {
        this.erro = false;
      },
      inRange(codigo) {
        const divMensagem = document.getElementById("mensagem");
  
        if (codigo > 9 || codigo <= 0) {
          divMensagem.style.display = "block";
        }
  
        if (codigo <= 9 && codigo > 0) {
          divMensagem.style.display = "none";
        }
  
        if (codigo == '') {
          divMensagem.style.display = "none";
        }
      },
    },
  };
</script>
  
  
<style lang="scss" scoped>
@import "../../styles/catalogoForm.scss";

.wrapper .form.centro p.texto-asterisco {
  color: #005516 !important;
  font-size: 0.9rem !important;
  margin-bottom: 1rem !important;
  font-family: "Montserrat-Medium", sans-serif !important;
}
</style>
